import {DASHBOARD_SET_STATE, DASHBOARD_SET_WORKSHEETS} from './types';

export const mutations = {
  [DASHBOARD_SET_STATE]: (state, payload) => {
    state.dashboard.category = payload.category;
    state.dashboard.columns = payload.columns;
    state.dashboard.data = payload.data;
    state.dashboard.groups = payload.groups;
    state.dashboard.id = payload.id;
    state.dashboard.measures = payload.measures;
    state.dashboard.name = payload.name;
    state.dashboard.rows = payload.rows;
    state.dashboard.title = payload.title;
    state.dashboard.type = payload.type;
    state.dashboard.url = payload.url;
  },

  [DASHBOARD_SET_WORKSHEETS]: (state, payload) => {
    state.dashboard.worksheets = payload;
  }
};
